export default "__VITE_ASSET__GcxJ16ha__"